const FALLBACK_RETURN_TO = '/';
const AUTH_PATH_SEGMENTS = ['login', 'signup'];
const SERVER_RENDERED_PATH_PREFIXES = ['/internal', '/backoffice', '/api/oauth'];

const hasControlCharacter = (value: string): boolean => {
  for (let i = 0; i < value.length; i += 1) {
    if (value.charCodeAt(i) < 0x20) {
      return true;
    }
  }
  return false;
};

const unwrapJsonQuoted = (value: string): string => {
  if (!value.startsWith('"') || !value.endsWith('"')) {
    return value;
  }
  try {
    const parsed: unknown = JSON.parse(value);
    return typeof parsed === 'string' ? parsed : value;
  } catch {
    return value;
  }
};

export const resolveSafeReturnTo = (raw: unknown): string => {
  if (typeof raw !== 'string' || raw.length === 0) {
    return FALLBACK_RETURN_TO;
  }

  const value = unwrapJsonQuoted(raw);

  if (
    !value.startsWith('/') ||
    value.startsWith('//') ||
    value.includes('\\') ||
    hasControlCharacter(value)
  ) {
    return FALLBACK_RETURN_TO;
  }

  let url: URL;
  try {
    url = new URL(value, window.location.origin);
  } catch {
    return FALLBACK_RETURN_TO;
  }

  if (url.origin !== window.location.origin || url.pathname.startsWith('//')) {
    return FALLBACK_RETURN_TO;
  }

  if (AUTH_PATH_SEGMENTS.some((segment) => url.pathname.toLowerCase().includes(segment))) {
    return FALLBACK_RETURN_TO;
  }

  return `${url.pathname}${url.search}${url.hash}`;
};

export const isServerRenderedPath = (path: string): boolean => {
  const pathname = path.split(/[?#]/)[0];
  return SERVER_RENDERED_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
};
